import React, { createContext, useContext, useMemo, useState } from "react";

/**
 * Carrega título/descrição da página atual até o topbar (modelo Zendenta —
 * cabeçalho da página no topo). O `AdminPageLayout` publica `{ path, title,
 * description }` e o `AppTopBar` consome, exibindo apenas quando o `path`
 * casa com a rota atual (evita título "preso" ao navegar).
 */
const PageHeaderContext = createContext({
  header: { path: "", title: "", description: "" },
  setHeader: () => {},
});

export function PageHeaderProvider({ children }) {
  const [header, setHeader] = useState({ path: "", title: "", description: "" });
  const value = useMemo(() => ({ header, setHeader }), [header]);
  return <PageHeaderContext.Provider value={value}>{children}</PageHeaderContext.Provider>;
}

export const usePageHeader = () => useContext(PageHeaderContext);

export default PageHeaderContext;
